import {isCoches} from '../../utils.js'
import cochesMiddlewares from './coches/index.js'
import motosMiddlewares from './motos/index.js'

const middlewares = isCoches ? cochesMiddlewares : motosMiddlewares

export default () => {
  middlewares.forEach(middleware => {
    const [destination] = Object.keys(middleware)
    const destinationMiddlewares = middleware[destination]

    window.analytics.addDestinationMiddleware(destination, destinationMiddlewares)
  })
}
